import React from 'react';
import { AuthProvider } from './hooks/useAuth';
import { AppRouter } from './routes/AppRouter';
import { PushMessagingBootstrap } from './bootstrap/PushMessagingBootstrap';
import { PwaServiceWorkerUpdate } from './bootstrap/PwaServiceWorkerUpdate';
import { ThemeProvider } from './context/ThemeContext';

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <PwaServiceWorkerUpdate />
        <PushMessagingBootstrap />
        <AppRouter />
      </AuthProvider>
    </ThemeProvider>
  );
}
